export type YearlyRenewalsAndApplications = {
    year: number;
    renewals: number;
    applications: number;
    total: number;
};

type ClassRegistrations = { class: string; count: number };

export type RegistrationsPerClass = {
    countByTop12Classes: ClassRegistrations[];
    totalCaseCount: number;
};

export type FutureEstimatedRenewalCost = {
    year: number;
    estimatedRenewalCosts: number;
    estimatedRenewalCostsPerMonth: number[];
};

export type FutureEstimatedRenewalCostsViewMode = "year" | "month";

export type FutureEstimatedRenewalCostsView = {
    mode: FutureEstimatedRenewalCostsViewMode;
    selectedYear: number;
};

export const futureEstimatedRenewalCostsViewStorageKey = "ipportal-future-estimated-renewal-costs-view";

export const monthLabels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export type WidgetConfig<T> = {
    data: T;
    isLoading: boolean;
    serviceUnavailable: boolean;
    accessDenied: boolean;
};
